import React from "react";

/**
 * Global SVG filters used across the app.
 * `logo-key`: turns the black background of the GARNACHA logo into transparency
 * by computing alpha = clamp(3*(R+G+B)). Pure black → 0, orange/cream → 1.
 */
const BrandFilters = () => (
  <svg
    aria-hidden="true"
    width="0"
    height="0"
    style={{ position: "absolute", width: 0, height: 0 }}
  >
    <defs>
      <filter id="logo-key" colorInterpolationFilters="sRGB">
        <feColorMatrix
          type="matrix"
          values="
            1 0 0 0 0
            0 1 0 0 0
            0 0 1 0 0
            3 3 3 0 0
          "
        />
      </filter>
    </defs>
  </svg>
);

export default BrandFilters;
